export const COMMERCETOOLS_ACCESS_TOKEN_URL = "https://auth.europe-west1.gcp.commercetools.com";
export const COMMERCETOOLS_API_URL = "https://api.europe-west1.gcp.commercetools.com";
export const COMMERCETOOLS_MERCHANT_CENTER_URL = `https://mc.europe-west1.gcp.commercetools.com/${process.env.NEXT_PUBLIC_COMMERCETOOLS_PROJECT_KEY}`;
export const COMMERCETOOLS_PROJECT_API_URL = `${COMMERCETOOLS_API_URL}/${process.env.NEXT_PUBLIC_COMMERCETOOLS_PROJECT_KEY}`;
export const STORE_FRONT_EMAIL_SUBSCRIPTION_ENDPOINT = "Consent/newslettersignup";
export const STORE_FRONT_ORDER_HISTORY_ENDPOINT = "Order/OrderHistory";
